import IndexRouter from './router/IndexRouter'
import './App.css'
import React from "react";

function App(){
  return <IndexRouter/>
}
export default App